import isEmpty from 'lodash/isEmpty'

import { ROUTES } from '@router'

export const buildBreadcrumb = (dataFromAPI) => {
  if (isEmpty(dataFromAPI)) {
    return {}
  }

  if (dataFromAPI.length === 1) {
    return { pageTitle: dataFromAPI[0].displayName }
  }

  const [first, ...intermediary] = dataFromAPI.slice(0, -1)
  const [last] = dataFromAPI.slice(-1)

  return {
    pageTitle: last.displayName,
    pageSlug: last.link || {},
    ancestorPaths: [
      {
        title: first.displayName,
        slug: { name: ROUTES.BUYING_GUIDE.ROOT_HUB },
      },
      ...intermediary.map(({ displayName: title, link }) => ({
        title,
        slug: link || {},
      })),
    ],
  }
}
